import { Track } from "@/modules/property-tracks/types";
import useEditTrackAssignedUser from "@/modules/property-tracks/hooks/edit-track-assigned-user.hook";
import FieldWrapper from "@/modules/lead-page/new/components/sidebar/fields/field-wrapper";
import EditTrackAssignedUser from "../../desktop/property-stage/edit-assigned-user";
import LeadAgentEditable from "../../lead-status/lead-agent-editable";

function TrackUserAgent({
  track,
  editable = false,
}: Readonly<{ track: Track; editable?: boolean }>) {
  const { assignedUser } = useEditTrackAssignedUser({ track });

  return (
    <LeadAgentEditable
      onClose={() => assignedUser.setEditAssignedUserModalOpen(false)}
      open={assignedUser.editAssignedUserModalOpen}
      title="Edit Assigned User"
      confirmButtonText="Save"
      cancelButtonText="Cancel"
      onConfirm={() => assignedUser.handleAssignTrack()}
      isLoading={assignedUser.isLoading}
      isConfirmDisabled={!assignedUser.state}
      snapPoints={[1]}
      editable={editable}
      name={track?.user?.name}
      color={track?.user?.color}
      handleEdit={() => assignedUser.setEditAssignedUserModalOpen(true)}
      sx={{ height: "100%" }}
    >
      <FieldWrapper>
        <EditTrackAssignedUser assignedUser={assignedUser} track={track} />
      </FieldWrapper>
    </LeadAgentEditable>
  );
}

export default TrackUserAgent;
